'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { withRouter } from 'react-router-dom';
export default (Component => withRouter(props => {
  const {
    location,
    history
  } = props;
  const setQueryParam = useCallback((key, value, addToHistory, keysToDelete = []) => {
    const query = new URLSearchParams(location.search);

    for (const keyToDelete of keysToDelete) {
      query.delete(keyToDelete);
    }

    query.set(key, value);
    const queryString = query.toString();

    if (addToHistory) {
      history.push(`${location.pathname}?${queryString}`);
    } else {
      history.replace(`${location.pathname}?${queryString}`);
    }
  }, [history, location]);
  const deleteQueryParam = useCallback((keysToDelete = []) => {
    const query = new URLSearchParams(location.search);

    for (const keyToDelete of keysToDelete) {
      query.delete(keyToDelete);
    }

    const queryString = query.toString();
    history.push(`${location.pathname}?${queryString}`);
  }, [history, location]);
  return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
    setQueryParam: setQueryParam,
    deleteQueryParam: deleteQueryParam,
    query: new URLSearchParams(location.search)
  }));
}));